module.exports = __webpack_public_path__ + "img/伤者家中调查-影像信息@2x.cf1bd385.png";